module.exports = __webpack_public_path__ + "img/utilityvalvac_driving.09c11093.svg";